import { render, staticRenderFns } from "./RegistroPublico.vue?vue&type=template&id=002f30ec&scoped=true&"
import script from "./RegistroPublico.vue?vue&type=script&lang=ts&"
export * from "./RegistroPublico.vue?vue&type=script&lang=ts&"
import style0 from "./RegistroPublico.vue?vue&type=style&index=0&id=002f30ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f30ec",
  null
  
)

export default component.exports